import http from './http'
import FileSaver from 'file-saver'
import Vue from 'vue'

export function downloadCompanyEnvironment (url) {
	return http.get(url, {
		responseType: 'blob',
	})
		.then((resp) => {
			let file = new Blob([resp.data], { type: 'text/plain;charset=utf-8' })
			let name = resp.headers['content-disposition'].split("filename*=UTF-8''")[1]
			FileSaver.saveAs(file, name)
		})
		.catch(error => {
			console.log(error)
			Vue.rollbar.error('downloadCompanyEnvironment', error)
		})
}

export function downloadManager (url, name) {
	if (name) {
		url += '?name=' + escape(name)
	}
	let token = localStorage.getItem('user-token') || ''
	let urlWithToken = new URL(process.env.VUE_APP_NODE_API_URL + url)
	urlWithToken.searchParams.set('token', token)
	window.location.href = urlWithToken
}
